/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import SelectQuestion from '../../../components/mobile/speak-doctor/SelectQuestion';
import DateQuestion from '../../../components/mobile/speak-doctor/DateQuestion';
import TextAreaQuestion from '../../../components/mobile/speak-doctor/TextAreaQuestion';
import SliderQuestion from '../../../components/mobile/speak-doctor/SliderQuestion';

const mobileCurrentPregnantRoutes = [
  {
    id: '1',
    path: '/speak-doctor/pregnancy/current-pregnant/first-day-last-period',
    component: (props) => <DateQuestion {...props} />,
    props: {
      fieldName: 'LastPeridDate',
      prevRoutePath: '/speak-doctor/pregnancy',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/when-positive-being-pregnant',
      title: 'speak-doctor:pregnant.currentPregnant.firstDayLastPeriod',
      subtitle: 'speak-doctor:pregnant.currentPregnant.dontKnow',
      isLastQuestion: false,
    },
  },
  {
    id: '2',
    path: '/speak-doctor/pregnancy/current-pregnant/when-positive-being-pregnant',
    component: (props) => <DateQuestion {...props} />,
    props: {
      fieldName: 'PregnantTestPositiveDate',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/first-day-last-period',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/where-did-pregnancy-test',
      title: 'speak-doctor:pregnant.currentPregnant.whenTestPositivePregnant',
      subtitle: 'speak-doctor:pregnant.currentPregnant.dontKnow',
      isLastQuestion: false,
    },
  },
  {
    id: '3',
    path: '/speak-doctor/pregnancy/current-pregnant/where-did-pregnancy-test',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'WherePregnancyTest',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/when-positive-being-pregnant',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/is-pregnancy-wanted-or-unwanted',
      title: 'speak-doctor:pregnant.currentPregnant.whereDidPregnantTest',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Home',
          label: 'speak-doctor:pregnant.currentPregnant.options1.home',
        },
        {
          value: 'Hospital',
          label: 'speak-doctor:pregnant.currentPregnant.options1.hospital',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '4',
    path: '/speak-doctor/pregnancy/current-pregnant/is-pregnancy-wanted-or-unwanted',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'PregnancyWantedUnWanted',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/where-did-pregnancy-test',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/have-visited-gynecologist',
      title: 'speak-doctor:pregnant.currentPregnant.isYourPregnanWanted',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Wanted',
          label: 'speak-doctor:pregnant.currentPregnant.options2.wanted',
        },
        {
          value: 'Unwanted',
          label: 'speak-doctor:pregnant.currentPregnant.options2.unwanted',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '5',
    path: '/speak-doctor/pregnancy/current-pregnant/have-visited-gynecologist',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'VisitedGynecologist',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/is-pregnancy-wanted-or-unwanted',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/during-pregnancy-following-examinations',
      title: 'speak-doctor:pregnant.currentPregnant.haveYouVisitedGynecologist',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '6',
    path: '/speak-doctor/pregnancy/current-pregnant/during-pregnancy-following-examinations',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'AnyExamination',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/have-visited-gynecologist',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/have-you-taking-floc-acid',
      title: 'speak-doctor:pregnant.currentPregnant.duringPregnancyFollowingExaminations',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectAllAsnwer',
      isLastQuestion: false,
      isMultiSelect: true,
      options: [
        {
          value: 'Urine Exam',
          label: 'speak-doctor:pregnant.currentPregnant.options4.urineExam',
        },
        {
          value: 'Blood Exam',
          label: 'speak-doctor:pregnant.currentPregnant.options4.bloodExam',
        },
        {
          value: 'Ultrasound',
          label: 'speak-doctor:pregnant.currentPregnant.options4.ultraSound',
        },
        {
          value: 'Widal Test',
          label: 'speak-doctor:pregnant.currentPregnant.options4.widalTest',
        },
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '7',
    path: '/speak-doctor/pregnancy/current-pregnant/have-you-taking-floc-acid',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'TakingFolicAcid',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/during-pregnancy-following-examinations',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/experiencing-morning-sickness-during-pregnancy',
      title: 'speak-doctor:pregnant.currentPregnant.haveYouTakingFolicAcid',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '8',
    path: '/speak-doctor/pregnancy/current-pregnant/experiencing-morning-sickness-during-pregnancy',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'ExpriencingMorningSickNess',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/have-you-taking-floc-acid',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/experiencing-bleeding-during-pregnancy',
      title: 'speak-doctor:pregnant.currentPregnant.areYouExperiencingMorningSickness',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '9',
    path: '/speak-doctor/pregnancy/current-pregnant/experiencing-bleeding-during-pregnancy',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'AnyBleeding',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/experiencing-morning-sickness-during-pregnancy',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/how-many-children-have-you-given-birth-previously',
      title: 'speak-doctor:pregnant.currentPregnant.haveYouExperiencedBleeding',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '10',
    path: '/speak-doctor/pregnancy/current-pregnant/how-many-children-have-you-given-birth-previously',
    component: (props) => <SliderQuestion {...props} />,
    props: {
      fieldName: 'HowManyChildren',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/experiencing-bleeding-during-pregnancy',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/were-birth-natural-or-caesarean',
      title: 'speak-doctor:pregnant.currentPregnant.howManyChildrenHaveYouGiven',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectNumberOfChildren',
      sliderTextValue: 'speak-doctor:covid.question2.yearOld',
      sliderMinValue: 0,
      sliderMaxValue: 30,
      isLastQuestion: false,
      boxWidth: '100%'
    },
  },
  {
    id: '11',
    path: '/speak-doctor/pregnancy/current-pregnant/were-birth-natural-or-caesarean',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'NaturalOrCaesarean',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/how-many-children-have-you-given-birth-previously',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/use-any-form-of-contraception',
      title: 'speak-doctor:pregnant.currentPregnant.ifHaveGivenBirthWereTheBirth',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Natural Birth',
          label: 'speak-doctor:pregnant.currentPregnant.options5.naturalBirth',
        },
        {
          value: 'Caesarean Birth',
          label: 'speak-doctor:pregnant.currentPregnant.options5.caesarBirth',
        },
        {
          value: 'Both',
          label: 'speak-doctor:pregnant.currentPregnant.options5.both',
        },
        {
          value: 'Not applicable',
          label: 'speak-doctor:pregnant.currentPregnant.options5.notApplicable',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '12',
    path: '/speak-doctor/pregnancy/current-pregnant/use-any-form-of-contraception',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'AnyFormofContraception',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/were-birth-natural-or-caesarean',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/if-known-what-is-your-blood-type',
      title: 'speak-doctor:pregnant.currentPregnant.doYouCurrentlyUseContraception',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '13',
    path: '/speak-doctor/pregnancy/current-pregnant/if-known-what-is-your-blood-type',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'BloodType',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/use-any-form-of-contraception',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/history-of-miscarriage',
      title: 'speak-doctor:pregnant.currentPregnant.ifKnowBloodType',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'O negative',
          label: 'speak-doctor:pregnant.currentPregnant.options6.oNegative',
        },
        {
          value: 'O positive',
          label: 'speak-doctor:pregnant.currentPregnant.options6.oPositive',
        },
        {
          value: 'A negative',
          label: 'speak-doctor:pregnant.currentPregnant.options6.aNegative',
        },
        {
          value: 'A positive',
          label: 'speak-doctor:pregnant.currentPregnant.options6.aPositive',
        },
        {
          value: 'B negative',
          label: 'speak-doctor:pregnant.currentPregnant.options6.bNegative',
        },
        {
          value: 'B positive',
          label: 'speak-doctor:pregnant.currentPregnant.options6.bPositive',
        },
        {
          value: 'AB negative',
          label: 'speak-doctor:pregnant.currentPregnant.options6.abNegative',
        },
        {
          value: 'AB positive',
          label: 'speak-doctor:pregnant.currentPregnant.options6.abPositive',
        },
        {
          value: 'Unknown',
          label: 'speak-doctor:pregnant.currentPregnant.unknown',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '14',
    path: '/speak-doctor/pregnancy/current-pregnant/history-of-miscarriage',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'MiscarriageHistory',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/if-known-what-is-your-blood-type',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/history-of-thypoid-fever',
      title: 'speak-doctor:pregnant.currentPregnant.doYouHaveHistoryMiscarriage',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '15',
    path: '/speak-doctor/pregnancy/current-pregnant/history-of-thypoid-fever',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'TyphoidFever',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/history-of-miscarriage',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/have-experienced-high-blood-pressure',
      title: 'speak-doctor:pregnant.currentPregnant.doYouHaveHistoryTyphoid',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '16',
    path: '/speak-doctor/pregnancy/current-pregnant/have-experienced-high-blood-pressure',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'ExperinacingHighBloodPressure',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/history-of-thypoid-fever',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/when-you-last-visit-doctor',
      title: 'speak-doctor:pregnant.currentPregnant.haveYouExperiencedHighBloodPressure',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectOneAnswer',
      isLastQuestion: false,
      options: [
        {
          value: 'Yes',
          label: 'speak-doctor:pregnant.currentPregnant.options3.yes',
        },
        {
          value: 'No',
          label: 'speak-doctor:pregnant.currentPregnant.options3.no',
        }
      ],
      boxWidth: '100%'
    },
  },
  {
    id: '17',
    path: '/speak-doctor/pregnancy/current-pregnant/when-you-last-visit-doctor',
    component: (props) => <DateQuestion {...props} />,
    props: {
      fieldName: 'LastDoctorVisitDate',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/have-experienced-high-blood-pressure',
      nextRoutePath: '/speak-doctor/pregnancy/current-pregnant/speak-to-doctor',
      title: 'speak-doctor:pregnant.currentPregnant.whenYouLastVisitDoctor',
      subtitle: 'speak-doctor:pregnant.currentPregnant.selectDateBelow',
      isLastQuestion: false
    }
  },
  {
    id: '18',
    path: '/speak-doctor/pregnancy/current-pregnant/speak-to-doctor',
    component: (props) => <TextAreaQuestion {...props} />,
    props: {
      fieldName: 'WhatWouldLikeToSpeakToDoctor',
      prevRoutePath: '/speak-doctor/pregnancy/current-pregnant/when-you-last-visit-doctor',
      nextRoutePath: '',
      title: 'speak-doctor:pregnant.currentPregnant.whatYouLikeSpeakToDoctor',
      subtitle: '',
      isLastQuestion: true,
    },
  },
];

export const getMobileCurrentPregnantRoutes = () => mobileCurrentPregnantRoutes;
